import { NotFoundError } from '~/components/Error/NotFoundError';

export default NotFoundError;
